import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { I18nModule, provideConfig } from '@spartacus/core';

import { DpDownloadsCmsComponent } from './downloads-cms.component';
import { DpDownloadItemComponent } from '@app/ui-components/download-item';

@NgModule({
  declarations: [DpDownloadsCmsComponent],
  exports: [DpDownloadsCmsComponent],
  imports: [AsyncPipe, I18nModule, MatIcon, DpDownloadItemComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        DpDownloadsComponent: {
          component: DpDownloadsCmsComponent
        }
      }
    })
  ]
})
export class DpDownloadsCmsModule {}
